import React from "react";
import { MoneyDisplayHelper } from "../../../../../../react-core/Helpers/MoneyDisplayHelper";
import { formatMoney } from "../../../../../../react-core/Utils/Money";
import { CurrencyCode } from "../../../../../../Wrap/Constants/Enums/Domain/CurrencyCode";
import { RegularPaymentType } from "../../../../../../Wrap/Constants/Enums/Domain/RegularPaymentType";
import { ProductRegularPayment } from "../../../../../../Wrap/Models/Domains/Valuation/ProductRegularPayment";
import { RegularPaymentIn } from "../../../../../../Wrap/Models/Domains/Valuation/RegularPaymentIn";
import { InstructionType } from "../../../../../../Wrap/Models/Models/PortfolioAnalysis/Payment/InstructionType";
import { SubAccountTypeArrayMap } from "../../../../../Admin/Company/CompanyWizard/Resource/Content";
import { AriaTooltip } from "../../../../../Shared/Tooltip/AriaTooltip";
import { Typography } from "../../../../../Shared/Typography/Typography";
import { PortfolioViewActionMenuAdditionalInfoAction } from "../../../CustomNavigation/Action/PortfolioViewActionMenuAdditionalInfoAction";
import { FrequencyTypeArraysMaps } from "../../Common/Resource/Contents";

interface IAccountSearchRegularDetailsPopUp {
    headAccountHierarchyId: string;
    displayText: string;
    type: string;
}

export const AccountSearchRegularDetailsPopUp = (props: IAccountSearchRegularDetailsPopUp) => {
    if (!props.headAccountHierarchyId) {return null;}

    const [regularDetails, setRegularDetails] = React.useState([]);
    const [isLoading, setIsLoading] = React.useState(true);

    const getCustomerDetail = (headAccountHierarchyId: string) => {
        setIsLoading(true);
        if (props.type === "regularPayments" || props.type === "regularWithdrawals") {
            PortfolioViewActionMenuAdditionalInfoAction.getRegularPayment(headAccountHierarchyId, (res) => {
                setRegularDetails(res?.ProductPayments);
                setIsLoading(false);
            });
        } else {
            console.error("Invalid type");
            setIsLoading(false);
        }
    };

    const tooltipConfig = () => {
        const config = [];
        if (props.type === "regularPayments") {
            regularDetails.forEach((x: ProductRegularPayment) => {
                x?.Payments.forEach((y: RegularPaymentIn) => {
                    const isPercentage = y?.RegularPaymentType == RegularPaymentType.Percentage;
                    config.push(
                        { title: "Account", data: x?.ClAccountId },
                        { title: "Product type", data: SubAccountTypeArrayMap.optionsMap[x?.WrapperType] },
                        {
                            title: isPercentage ? "Percentage" : "Amount",
                            data:
                                y?.RegularPaymentType == RegularPaymentType.Percentage
                                    ? MoneyDisplayHelper.getPercentageFormat(y?.Percentage, 2)
                                    : MoneyDisplayHelper.getMoneyFormat(
                                          { Amount: y?.Amount, Currency: CurrencyCode.GBP },
                                          true,
                                          2
                                      ),
                        },
                        { title: "Frequency", data: FrequencyTypeArraysMaps[y?.Frequency] }
                    );
                });
            });
        } else if (props.type === "regularWithdrawals") {
            regularDetails.forEach((x: ProductRegularPayment) => {
                x?.Payments.forEach((y: RegularPaymentIn) => {
                    const isPercentage = y?.RegularPaymentType == RegularPaymentType.Percentage;
                    config.push(
                        { title: "Account", data: x?.ClAccountId },
                        { title: "Product type", data: SubAccountTypeArrayMap.optionsMap[x?.WrapperType] },
                        {
                            title: isPercentage ? "Percentage" : "Amount",
                            data:
                                y?.RegularPaymentType == RegularPaymentType.Percentage
                                    ? MoneyDisplayHelper.getPercentageFormat(y?.Percentage, 2)
                                    : MoneyDisplayHelper.getMoneyFormat(
                                          { Amount: y?.Amount, Currency: CurrencyCode.GBP },
                                          true,
                                          2
                                      ),
                        },
                        { title: "Frequency", data: FrequencyTypeArraysMaps[y?.Frequency] }
                    );
                });
            });
        }

        return config;
    };

    return (
        <AriaTooltip
            cssWrapper="is-underlined-text no-border-radius"
            buttonText={props.displayText}
            onClick={() => {
                getCustomerDetail(props.headAccountHierarchyId);
            }}
            onClose={() => {
                setRegularDetails([]);
            }}
            isLoading={isLoading}
        >
            <Typography type="auto-width" wrapCss="mt-10 mb-0" config={tooltipConfig()} />
        </AriaTooltip>
    );
};
